import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { GroupTypes } from '../../../models/school/group.model';

@Injectable({
  providedIn: 'root'
})
export class EvoGroupTypeModalService {

  isVisible = false;
  selectedType: string = GroupTypes.standard;

  private subscriber: Subscriber<string>;

  show(currentType: string): Observable<string> {
    this.selectedType = currentType || GroupTypes.standard;
    this.isVisible = true;
    return new Observable((subscriber: Subscriber<string>) => {
      this.subscriber = subscriber;
    });
  }

  confirm() {
    this.isVisible = false;
    if (this.subscriber) {
      this.subscriber.next(this.selectedType);
      this.subscriber.complete();
    }
  }

  hide() {
    this.isVisible = false;
    if (this.subscriber) {
      this.subscriber.complete();
    }
  }

}
